import { FeedbackTag } from '../menu-content/feedback-menu.data';

export const BAD_MATCH_REASONS: FeedbackTag[] = [
  {
    text: 'Missing basic skills',
    selected: false,
  },
  {
    text: 'Overqualified',
    selected: false,
  },
  {
    text: 'Underqualified',
    selected: false,
  },
  {
    text: 'Education mismatch',
    selected: false,
  },
  {
    text: 'Recent experience mismatch',
    selected: false,
  },
  {
    text: 'Industry mismatch',
    selected: false,
  },
  {
    text: 'Background/titles mismatch',
    selected: false,
  },
  {
    text: 'Corrupt candidate data',
    selected: false,
  },
];
